import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-0"}],["path",{"d":"M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2","key":"svg-1"}],["path",{"d":"M17 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1","key":"svg-2"}]]

const IconMathCos = createReactComponent('outline', 'math-cos', 'MathCos', __iconNode);

export default IconMathCos;